import { Button, Form } from "antd";
import AddressInput from "./AddressInput";
import WizardStepLayout from "./WizardStepLayout";

interface StepProps {
  gotoStep: Function;
  current: number;
  form?: any;
}

const ResidentialInfo: React.FC<StepProps> = ({ gotoStep, current, form }) => {
  const tailLayout = {
    labelCol: { span: 8 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const content = (
    <WizardStepLayout
      action={
        <Form.Item {...tailLayout} style={{ marginBottom: 0 }}>
          <Button block size="large" onClick={() => gotoStep(current + 1)}>
            Next
          </Button>
        </Form.Item>
      }
    >
      <AddressInput form={form} />
    </WizardStepLayout>
  );

  return content;
};
export default ResidentialInfo;
